import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { communityActions as actions, notificationActions } from '../actions';
import { communityService } from '../services';

/* Create Post Sagas */
function* handleCreatePostRequest() {
  const action = yield take(actions.createPostRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.createPost, dataParams);
    if (res.isError) {
      yield put(actions.createPostError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createPostSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.createPostError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get All Post Sagas*/
function* handleGetAllPostSagasRequest() {
  const action = yield take(actions.getAllPostRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.getAllPost, dataParams);

    if (res.isError) {
      yield put(actions.getAllPostError(res));

    } else {
      yield put(actions.getAllPostSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllPostError());
  }
}

/* Update Post Sagas */
function* handleUpdatePostRequest() {
  const action = yield take(actions.updatePostRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.updatePost, dataParams);
    if (res.isError) {
      yield put(actions.updatePostError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updatePostSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updatePostError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Delete Post Sagas*/
function* handleDeletePostRequest() {
  const action = yield take(actions.deletePostRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.deletePost, dataParams);
    if (res.isError) {
      yield put(actions.deletePostError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deletePostSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deletePostError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/*Post like  Sagas*/
function* handlePostLikeRequest() {
  const action = yield take(actions.postLikeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.postLike, dataParams);
    if (res.isError) {
      yield put(actions.postLikeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.postLikeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.postLikeError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*Post like By Id  Sagas*/
function* handlePostLikeByIdRequest() {
  const action = yield take(actions.postLikeByIdRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.getLikeById, dataParams);
    if (res.isError) {
      yield put(actions.postLikeByIdError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.postLikeByIdSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.postLikeByIdError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*Post Comment  Sagas*/
function* handlePostCommentRequest() {
  const action = yield take(actions.postCommentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.postComment, dataParams);
    if (res.isError) {
      yield put(actions.postCommentError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.postCommentSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.postCommentError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*Post Comment By Id  Sagas*/
function* handlePostCommentByIdRequest() {
  const action = yield take(actions.postCommentByIdRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.getCommentsById, dataParams);
    if (res.isError) {
      yield put(actions.postCommentByIdError(res));

    } else {
      yield put(actions.postCommentByIdSuccess(res));

    }
  } catch (error) {
    yield put(actions.postCommentByIdError());
  }
}

/*Comment Delete  Sagas*/
function* handleCommentDeleteRequest() {
  const action = yield take(actions.deleteCommentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.deleteComment, dataParams);
    if (res.isError) {
      yield put(actions.deleteCommentError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteCommentSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteCommentError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*Comment Update Sagas*/
function* handleCommentUpdateRequest() {
  const action = yield take(actions.updateCommentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.updateComment, dataParams);
    if (res.isError) {
      yield put(actions.updateCommentError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateCommentSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateCommentError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*Get Post Sagas*/
function* handleGetPostRequest() {
  const action = yield take(actions.getPostRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.getPost, dataParams);
    if (res.isError) {
      yield put(actions.getPostError(res));
    } else {
      yield put(actions.getPostSuccess(res));
    }
  } catch (error) {
    yield put(actions.getPostError());
  }
}
/*Get Post Counts Sagas*/
function* handleGetPostCountsRequest() {
  const action = yield take(actions.getPostCountsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.getPostCounts, dataParams);
    if (res.isError) {
      yield put(actions.getPostCountsError(res));
    } else {
      yield put(actions.getPostCountsSuccess(res));
    }
  } catch (error) {
    yield put(actions.getPostCountsError());
  }
}

/*Get Post Counts Sagas*/
function* handleGetAnnouncementRequest() {
  const action = yield take(actions.getAnnouncementRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.getAnnouncement, dataParams);
    if (res.isError) {
      yield put(actions.getAnnouncementError(res));

    } else {
      yield put(actions.getAnnouncementSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAnnouncementError());
  }
}


/*Add Post Counts Sagas*/
function* handleAddAnnouncementRequest() {
  const action = yield take(actions.addAnnouncementRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.addAnnouncement, dataParams);
    if (res.isError) {
      yield put(actions.addAnnouncementError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addAnnouncementSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.addAnnouncementError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/* Update Announcement Sagas */
function* handleUpdateAnnouncementRequest() {
  const action = yield take(actions.updateAnnouncementRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.updateAnnouncement, dataParams);
    if (res.isError) {
      yield put(actions.updateAnnouncementError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateAnnouncementSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateAnnouncementError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Delete Announcement Sagas */
function* handleDeleteAnnouncementRequest() {
  const action = yield take(actions.deleteAnnouncementRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.deleteAnnouncement, dataParams);
    if (res.isError) {
      yield put(actions.deleteAnnouncementError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteAnnouncementSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteAnnouncementError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/* Delete Announcement Sagas */
function* handleGetPopUpAnnouncementRequest() {
  const action = yield take(actions.getPopUpAnnouncementRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.getPopUpAnnouncement, dataParams);
    if (res.isError) {
      yield put(actions.getPopUpAnnouncementError(res));

    } else {
      yield put(actions.getPopUpAnnouncementSuccess(res));
    }
  } catch (error) {
    yield put(actions.getPopUpAnnouncementError());
  }
}

/* Delete Announcement Sagas */
function* handleGetWebcastRequest() {
  const action = yield take(actions.getWebcastRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.getWebcast, dataParams);
    if (res.isError) {
      yield put(actions.getWebcastError(res));

    } else {
      yield put(actions.getWebcastSuccess(res));
    }
  } catch (error) {
    yield put(actions.getWebcastError());
  }
}

/* Delete Announcement Sagas */
function* handleGetAllAnnouncementRequest() {
  const action = yield take(actions.getAllAnnouncementRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.getAllAnnouncement, dataParams);
    if (res.isError) {
      yield put(actions.getAllAnnouncementError(res));

    } else {
      yield put(actions.getAllAnnouncementSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllAnnouncementError());
  }
}

/* Get Alert Announcement Sagas */
function* handleGetAlertAnnouncementRequest() {
  const action = yield take(actions.getAlertAnnouncementRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(communityService.getAlertAnnouncement, dataParams);
    if (res.isError) {
      yield put(actions.getAlertAnnouncementError(res));

    } else {
      yield put(actions.getAlertAnnouncementSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAlertAnnouncementError());
  }
}
/* -----------Watchers------------- */
function* handleCreatePostWatcher() {
  yield takeEvery(
    actions.createPostRequest,
    handleCreatePostRequest,
  );
}

function* handleUpdatePostWatcher() {
  yield takeEvery(
    actions.updatePostRequest,
    handleUpdatePostRequest,
  );
}

function* handleGetAllPostWatcher() {
  yield takeEvery(
    actions.getAllPostRequest,
    handleGetAllPostSagasRequest,
  );
}

function* handleDeletePostWatcher() {
  yield takeEvery(
    actions.deletePostRequest,
    handleDeletePostRequest,
  );
}

function* handlePostLikeWatcher() {
  yield takeEvery(
    actions.postLikeRequest,
    handlePostLikeRequest,
  );
}

function* handlePostLikeByIdWatcher() {
  yield takeEvery(
    actions.postLikeByIdRequest,
    handlePostLikeByIdRequest,
  );
}

function* handlePostCommentWatcher() {
  yield takeEvery(
    actions.postCommentRequest,
    handlePostCommentRequest,
  );
}

function* handlePostCommentByIdWatcher() {
  yield takeEvery(
    actions.postCommentByIdRequest,
    handlePostCommentByIdRequest,
  );
}

function* handleDeleteCommentWatcher() {
  yield takeEvery(
    actions.deleteCommentRequest,
    handleCommentDeleteRequest,
  );
}

function* handleUpdateCommentWatcher() {
  yield takeEvery(
    actions.updateCommentRequest,
    handleCommentUpdateRequest,
  );
}


function* handleGetPostWatcher() {
  yield takeEvery(
    actions.getPostRequest,
    handleGetPostRequest,
  );
}
function* handleGetPostCountsWatcher() {
  yield takeEvery(
    actions.getPostCountsRequest,
    handleGetPostCountsRequest,
  );
}

function* handleGetAnnouncementWatcher() {
  yield takeEvery(
    actions.getAnnouncementRequest,
    handleGetAnnouncementRequest,
  );
}

function* handleAddAnnouncementWatcher() {
  yield takeEvery(
    actions.addAnnouncementRequest,
    handleAddAnnouncementRequest,
  );
}

function* handleUpdateAnnouncementWatcher() {
  yield takeEvery(
    actions.updateAnnouncementRequest,
    handleUpdateAnnouncementRequest,
  );
}

function* handleDeleteAnnouncementWatcher() {
  yield takeEvery(
    actions.deleteAnnouncementRequest,
    handleDeleteAnnouncementRequest,
  );
}


function* handleGetPopUpAnnouncementWatcher() {
  yield takeEvery(
    actions.getPopUpAnnouncementRequest,
    handleGetPopUpAnnouncementRequest,
  );
}
function* handleGetWebcastWatcher() {
  yield takeEvery(
    actions.getWebcastRequest,
    handleGetWebcastRequest,
  );
}


function* handleGetAllAnnouncementWatcher() {
  yield takeEvery(
    actions.getAllAnnouncementRequest,
    handleGetAllAnnouncementRequest,
  );
}


function* handleGetAlertAnnouncementWatcher() {
  yield takeEvery(
    actions.getAlertAnnouncementRequest,
    handleGetAlertAnnouncementRequest,
  );
}



function* rootDepartmentSaga() {
  yield all([
    handleCreatePostRequest(),
    handleCreatePostWatcher(),

    handleUpdatePostRequest(),
    handleUpdatePostWatcher(),

    handleGetAllPostSagasRequest(),
    handleGetAllPostWatcher(),

    handleDeletePostRequest(),
    handleDeletePostWatcher(),

    handlePostLikeRequest(),
    handlePostLikeWatcher(),

    handlePostLikeByIdRequest(),
    handlePostLikeByIdWatcher(),

    handlePostCommentRequest(),
    handlePostCommentWatcher(),

    handlePostCommentByIdRequest(),
    handlePostCommentByIdWatcher(),

    handleCommentDeleteRequest(),
    handleDeleteCommentWatcher(),

    handleCommentUpdateRequest(),
    handleUpdateCommentWatcher(),

    handleGetPostRequest(),
    handleGetPostWatcher(),

    handleGetPostCountsRequest(),
    handleGetPostCountsWatcher(),

    handleAddAnnouncementRequest(),
    handleAddAnnouncementWatcher(),

    handleGetAnnouncementRequest(),
    handleGetAnnouncementWatcher(),

    handleUpdateAnnouncementRequest(),
    handleUpdateAnnouncementWatcher(),

    handleDeleteAnnouncementRequest(),
    handleDeleteAnnouncementWatcher(),

    handleGetPopUpAnnouncementRequest(),
    handleGetPopUpAnnouncementWatcher(),

    handleGetWebcastRequest(),
    handleGetWebcastWatcher(),

    handleGetAllAnnouncementRequest(),
    handleGetAllAnnouncementWatcher(),

    handleGetAlertAnnouncementRequest(),
    handleGetAlertAnnouncementWatcher(),
  ]);
}

export default rootDepartmentSaga;
